import { render, staticRenderFns } from "./RovinietaNavigation.vue?vue&type=template&id=170b643b&scoped=true"
import script from "./RovinietaNavigation.vue?vue&type=script&lang=js"
export * from "./RovinietaNavigation.vue?vue&type=script&lang=js"
import style0 from "./RovinietaNavigation.vue?vue&type=style&index=0&id=170b643b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170b643b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('170b643b')) {
      api.createRecord('170b643b', component.options)
    } else {
      api.reload('170b643b', component.options)
    }
    module.hot.accept("./RovinietaNavigation.vue?vue&type=template&id=170b643b&scoped=true", function () {
      api.rerender('170b643b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RovinietaNavigation.vue"
export default component.exports